var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgEnvironment({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 83,
    height: 82,
    viewBox: "0 0 83 82",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M81.699.85a1.12 1.12 0 00-2.055-.295c-.736 1.243-6.664 3.18-12.398 5.052-4.767 1.555-10.17 3.322-15.591 5.509-14.768 5.961-29.41 12.882-36.496 23.067-5.514 7.928-6.185 21.602-1.422 27.297-.313 1.083-3.135 4.294-6.347 7.21-.072.058-1.765 1.46-3.168 2.89L.366 75.1c-.23.21-.36.506-.366.818-.002.31.123.611.348.825l5.178 4.946a1.124 1.124 0 001.829-.423c.026-.071 2.291-6.122 5.575-10.297 2.978-4.835 7.183-10.198 12.008-15.684l.624-24.083c.025-.931.847-1.675 1.728-1.64.93.025 1.664.798 1.64 1.728l-.523 20.14c3.193-3.475 6.575-6.956 9.984-10.348l.64-18.017c.033-.928.795-1.67 1.741-1.625.93.033 1.657.815 1.624 1.743l-.51 14.473c3.183-3.09 6.349-6.068 9.374-8.853l.63-10.99a1.687 1.687 0 011.778-1.586c.928.053 1.637.85 1.585 1.776l-.432 7.547c9.623-8.711 17.13-14.926 17.937-15.59a1.685 1.685 0 012.373.23 1.68 1.68 0 01-.232 2.367c-.186.158-6.93 5.74-15.954 13.852l11.132-1.606a1.686 1.686 0 01.479 3.335l-16.063 2.318c-3.276 3.001-6.73 6.243-10.202 9.61l19.311-1.92a1.684 1.684 0 01.333 3.353l-23.482 2.333a316.906 316.906 0 00-9.607 9.951l22.578-1.97a1.686 1.686 0 011.826 1.53 1.684 1.684 0 01-1.533 1.824l-26.022 2.272a1.68 1.68 0 01-.357.235c-2.475 2.813-4.776 5.582-6.811 8.248 2.353.735 5.28 1.118 8.634 1.118 11.053 0 23.995-3.986 31.474-9.693A54.364 54.364 0 0080.769 25.66C82.966 15.5 83.281 7.154 81.7.85"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnvironment);
export default __webpack_public_path__ + "static/media/environment.42bf7403.svg";
export { ForwardRef as ReactComponent };